// The names a signup's source may hold, apart from its schema, so the site's browser bundle can read them without zod.

/** Every name a source may hold, with the longest value kept. Nothing else is ever stored. */
export const SIGNUP_SOURCE_LIMITS = {
  utm_source: 200,
  utm_medium: 200,
  utm_campaign: 200,
  utm_term: 200,
  utm_content: 200,
  utm_id: 200,
  utm_topic: 200,
  fbclid: 500,
  gclid: 500,
  gbraid: 500,
  wbraid: 500,
  ttclid: 500,
  li_fat_id: 500,
  _fbc: 600,
  _fbp: 200,
  im_vid: 100,
  landing_url: 1500,
  referrer: 1500,
} as const;

export type SignupSourceName = keyof typeof SIGNUP_SOURCE_LIMITS;
export const SIGNUP_SOURCE_NAMES = Object.keys(SIGNUP_SOURCE_LIMITS) as ReadonlyArray<SignupSourceName>;

/**
 * The names that point at a person or a click: the click ids, Meta's cookies and the site's visitor id. The site shares them only under
 * consent, a link drops them when consent goes, and an account's source loses them at the click retention the privacy page states.
 * The campaign's `utm_*`, `landing_url` and `referrer` stay.
 */
export const SIGNUP_SOURCE_IDENTIFIERS = ["fbclid", "gclid", "gbraid", "wbraid", "ttclid", "li_fat_id", "_fbc", "_fbp", "im_vid"] as const satisfies ReadonlyArray<SignupSourceName>;

/** The names that hold a page's address: kept as `cleanPageUrl` gives them, http(s) only, without query or fragment. */
export const SIGNUP_SOURCE_URLS = ["landing_url", "referrer"] as const satisfies ReadonlyArray<SignupSourceName>;
